import "./Loader.scss";

const Loader = () => {
  return (
    <div className="netflix-loader-overlay">
      <div className="netflix-loader-spinner"></div>
    </div>
  );
};

export default Loader;
